import React, { useEffect, useState } from "react";
import { Box, Container, Grid } from "@mui/material";
import { useDispatch } from "react-redux";
import Activity from "../components/activity/Activity";
import PageTitle from "../../components/pageTitle/PageTitle";

import ClientList from "../components/client/ClientList";
import PageInfoTitle from "../../components/pageTitle/PageInfoTitle";
import DetailsCard from "../../components/detailCard/DetailsCard";
import DeletePopup from "../components/client/DeletePopup";
import ActivationPopup from "../components/client/ActivationPopup";
import ResetPasswordPopup from "../components/client/ResetPasswordPopup";
import SuspendPopup from "../components/client/SuspendPopup";
import CustomButton from "../../components/common/button/CustomButton";
import {
  getClientForEditAction,
  getSingleTelnetAction,
  getTelnetActivityAction,
  setAddTelnetAction,
  setNewClientLocal,
  setSingleTelnetAction,
} from "../../store/reducers/adminClientsSlice";
import { useSelector } from "react-redux";
import moment from "moment";
import StatusBadge from "../../components/common/StatusBadge";
import ManageTenant from "../components/client/manageClient/ManageTenant";
import { setNotificationAction } from "../../store/reducers/mmymSlice";

const SuperAdminClients = () => {
  const dispatch = useDispatch();
  const [tenantId, setTenantId] = useState(null);
  const [isUpdated, setIsUpdated] = useState(false);

  const { clientDetails, clientActivityResponse, isClientEditSuccess, newClientLocal, isAddClientSuccess } = useSelector(
    (state: any) => state.adminClients
  );

  useEffect(() => {
    if(tenantId){
    dispatch(getSingleTelnetAction(tenantId));
    dispatch(getTelnetActivityAction(tenantId));
    if(isAddClientSuccess){
      dispatch(setAddTelnetAction(false));
    }
  }
    setIsUpdated(false);
  }, [dispatch, tenantId, isUpdated, isAddClientSuccess]);

  useEffect(() => {
    return () => {
      dispatch(setNotificationAction({ message: [], severity: "error" }));
      dispatch(setSingleTelnetAction(null))
    }
  }, [])

  useEffect(() => {
    if(tenantId && isClientEditSuccess){
    dispatch(getSingleTelnetAction(tenantId));
    dispatch(getTelnetActivityAction(tenantId));
  }
    setIsUpdated(false);
  }, [dispatch, tenantId, isClientEditSuccess]);

  const clientData = [
    { id: "Client Name", value: `${clientDetails?.client_name}` },
    {
      id: "Company Address",
      value: `${clientDetails?.address}`,
    },
    { id: "Yard Post Code", value: `${clientDetails?.post_code}` },
    { id: "Company Email (the general one)", value: `${clientDetails?.email}` },
    { id: "Phone Number", value: `${clientDetails?.phone_number}` },
    {
      id: "Registration Date",
      value: clientDetails?.registration_date
        ? moment(clientDetails.registration_date).format("DD-MM-YYYY")
        : "",
    },
    { id: "Status", value: <StatusBadge status={clientDetails?.status} /> },
  ];

  const planDetails = [
    {
      id: "Subscription",
      value: `${clientDetails?.subscription === null ? "" : clientDetails?.subscription}`,
    },
    {
      id: "Action",
      value: (
        <StatusBadge
          status={clientDetails?.action === null ? "" : clientDetails?.action}
        />
      ),
    },
    {
      id: "Term",
      value: `${clientDetails?.start_date === null ? "" : moment(clientDetails?.start_date).format("DD/MM/YYYY")} - ${clientDetails?.end_date === null ? "" : moment(clientDetails?.end_date).format("DD/MM/YYYY")}`,
    },
    {
      id: "Payment Method",
      value: `${clientDetails?.payment_method === null ? "" : clientDetails?.payment_method}`,
    },
  ];

  const [open, setOpen] = useState(false); // State variable to manage dialog open/close
  const [activateModalShow, setActivateModalShow] = useState(false);
  const [suspendModalShow, setSuspendModalShow] = useState(false);
  const [resetPasswordModalShow, setResetPasswordModalShow] = useState(false);
  const [deleteModalShow, setDeleteModalShow] = useState(false);
  const [action, setAction] = useState('')

  const handleOpen = (action: any) => {
    setOpen(true);
    setAction(action)
    if(action === "edit"){
      if(tenantId){
        dispatch(getClientForEditAction(tenantId));
      }
    }
    if(action === "plan"){
      if(tenantId){
        dispatch(
          setNewClientLocal({
            ...newClientLocal,
            tenantId: tenantId
          })
        );
      }
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  const activeEventHandler = () => {
    setActivateModalShow(true);
  };

  const resetEventHandler = () => {
    setResetPasswordModalShow(true);
  };

  const suspendEventHandler = () => {
    setSuspendModalShow(true);
  };

  const deleteEventHandler = () => {
    setDeleteModalShow(true);
  };

  const hideHandle = () => {
    setDeleteModalShow(false);
    setActivateModalShow(false);
    setSuspendModalShow(false);
    setResetPasswordModalShow(false);
  };
  return (
    <>
      {open && (
        <ManageTenant
          selectClient={""}
          open={open}
          onHide={handleClose}
          title="Edit Client Details"
          action={action}
        />
      )}
      <ActivationPopup
        onHide={hideHandle}
        clientDetails={clientDetails}
        activateModalShow={activateModalShow}
        setActivateModalShow={setActivateModalShow}
      />
      <ResetPasswordPopup
        onHide={hideHandle}
        clientDetails={clientDetails}
        resetPasswordModalShow={resetPasswordModalShow}
        setResetPasswordModalShow={setResetPasswordModalShow}
        setIsUpdated={setIsUpdated}
        isUpdated={isUpdated}
        setTenantId={setTenantId}
      />
      <SuspendPopup
        onHide={hideHandle}
        clientDetails={clientDetails}
        suspendModalShow={suspendModalShow}
        setSuspendModalShow={setSuspendModalShow}
      />
      <DeletePopup
        onHide={hideHandle}
        clientDetails={clientDetails}
        deleteModalShow={deleteModalShow}
        setDeleteModalShow={setDeleteModalShow}
        setIsUpdated={setIsUpdated}
      />
      <Grid
        container
        rowSpacing={1}
        columnSpacing={{ xs: 1, sm: 2, md: 3 }}
        sx={{ background: "#f4f4f4", paddingTop: "16px" }}
      >
        <Grid item xs={12} md={6}>
          <Container
            maxWidth="md"
            sx={{ bgcolor: "#fff", padding: "16px 0px" }}
          >
            <Box
              sx={{
                bgcolor: "#fff",
                height: { xs: "auto", sm: "100vh" },
                border: "1px solid #d1cfcf",
                borderRadius: "5px",
                padding: "4px 12px",
              }}
            >
              <ClientList setTenantId={setTenantId} tenantId={tenantId} />
            </Box>
          </Container>
        </Grid>
        <Grid item xs={12} md={6}>
          <Container
            maxWidth="md"
            sx={{ bgcolor: "#fff", padding: "16px 0px" }}
          >
            {clientDetails ? (
              <>
                <Box
                  sx={{
                    bgcolor: "#fff",
                    height: { xs: "auto", sm: "100vh" },
                    border: "1px solid #d1cfcf",
                    borderRadius: "5px",
                    padding: "0px 16px",
                    overflow: "scroll",
                  }}
                >
                  <PageInfoTitle
                    title={clientDetails?.company_name}
                    desc={clientDetails?.company_strap_line}
                    editIcon={true}
                    onClickEdit={() => handleOpen('edit')}
                  />
                  <DetailsCard rows={clientData} />

                  <PageTitle title="Plan" button="Change" onClick={() => handleOpen('plan')} />

                  <DetailsCard rows={planDetails} />

                  <div className="btnGroup">
                    <CustomButton
                      // disabled={
                      //   clientDetails?.status === "PENDING" ? true : false
                      // }
                      // style={{
                      //   cursor:
                      //     clientDetails?.status === "PENDING"
                      //       ? "not-allowed"
                      //       : "pointer",
                      // }}
                      title={clientDetails?.is_active ? "Deactivate" : "Activate"}
                      onClick={activeEventHandler}
                    />
                    <CustomButton
                      // style={{ flex: "1 1 48%", margin: "2px 0" }}
                      title="Password Reset"
                      onClick={resetEventHandler}
                    />
                    <CustomButton
                      disabled={
                        clientDetails?.status === "PENDING" || clientDetails?.status === "INACTIVE" ? true : false
                      }
                      // style={{ flex: "1 1 48%", margin: "2px 0" }}
                      title={
                        clientDetails?.is_suspended && clientDetails?.status != "INACTIVE" ? "Unsuspend" : "Suspend"
                      }
                      onClick={suspendEventHandler}
                    />
                    <CustomButton
                      // style={{ flex: "1 1 48%", margin: "2px 0" }}
                      title="Delete"
                      onClick={deleteEventHandler}
                    />
                  </div>
                  <Activity clientActivityResponse={clientActivityResponse} />
                </Box>
              </>
            ) : (
              <>
                {/* when client details not apprear then show this screene */}
                <Box
                  sx={{
                    height: "100vh",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    position: "relative",
                    border: "1px solid #d1cfcf",
                    borderRadius: "5px",
                    padding: "0px 16px",
                  }}
                >
                  <span style={{ position: "absolute" }}>
                    Client details will appear here
                  </span>
                </Box>
              </>
            )}
          </Container>
        </Grid>
      </Grid>
    </>
  );
};

export default SuperAdminClients;
